import './ArtistSuggestionLoader.css';

const ArtistSuggestionLoader = ({ className = '' }) => {
  return (
    <div className={`artist-suggestion-loader ${className}`}></div>
  );
};

export default ArtistSuggestionLoader;
